module.exports = __webpack_public_path__ + "img/free-wifi-login-page.2333f111.webp";